import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c094d13&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./style/index.scss?vue&type=style&index=0&id=1c094d13&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c094d13",
  null
  
)

export default component.exports